import { Lotame } from './Lotame.js'

class DataConsentUtils {
  constructor (spinnaker) {
    this.spinnaker = spinnaker
    this.lotame = new Lotame()
  }

  async fetchDataConsentInfo (accountSummary) {
    // extract all consent option names from account which are set to true
    let optInOptions = []
    if (accountSummary.account.dataConsentOptions) {
      optInOptions = Object.keys(accountSummary.account.dataConsentOptions)
        .filter(k => accountSummary.account.dataConsentOptions[k] === true)
    }

    const compliance = await this.spinnaker.getCompliance()
    const tsAndCs = this.latestTsAndCs(compliance)
    const consent = this.latestConsent(compliance)
    const consentOptions = []
    const consentOptionKeysSelected = []
    for (let key in consent.options) {
      if (optInOptions.indexOf(key) > -1) {
        consentOptionKeysSelected.push(key)
      }

      consentOptions.push({
        key,
        description: consent.options[key]
      })
    }

    return {
      consentVersion: consent.version,
      consentLink: consent.detailLink,
      consentSummary: consent.summary,
      consentOptions,
      consentOptionKeysSelected,
      termsVersion: tsAndCs.version,
      termsLink: tsAndCs.detailLink,
      termsSummary: tsAndCs.summary,
      isConsentGiven: accountSummary.account.dataConsentVersion &&
        accountSummary.account.acceptedTermsAndConditionsVersion,
      isConsentUpToDate: accountSummary.account.dataConsentVersion === consent.version &&
        accountSummary.account.acceptedTermsAndConditionsVersion === tsAndCs.version
    }
  }

  latestConsent (complianceConfig) {
    if (!complianceConfig.data || !complianceConfig.data.consentVersions) {
      return null
    }

    let latestVersion = null
    for (const thisVersion of complianceConfig.data.consentVersions) {
      if (!latestVersion || latestVersion < thisVersion.version) {
        latestVersion = thisVersion
      }
    }
    return latestVersion
  }

  latestTsAndCs (complianceConfig) {
    if (!complianceConfig.data || !complianceConfig.data.termsAndConditionsVersions) {
      return null
    }

    let latestVersion = null
    for (const thisVersion of complianceConfig.data.termsAndConditionsVersions) {
      if (!latestVersion || latestVersion < thisVersion.version) {
        latestVersion = thisVersion
      }
    }
    return latestVersion
  }

  async recordChoices (accountSummary, termsVersion, consentVersion, consentChoices) {
    await this.spinnaker.recordTermsAndConditionsAcceptance(termsVersion)
    await this.spinnaker.recordDataConsentChoices(consentVersion, consentChoices)

    try {
      this.lotame.handleDataConsentUpdate(accountSummary, consentChoices)
    } catch (err) {
      console.info(`Failed to update Lotame (cookie blocker maybe?): ${err} - ignoring`)
    }
  }
}

export { DataConsentUtils }
